// Single source of truth for the receipt sizing settings (/outlet_form > Settings):
// the thermal paper width and the logo widths for each print family.
//
// These defaults ARE the values the receipt templates fall back to, so the outlet form
// and the templates can never drift apart.

// Thermal roll width (mm). 58 and 80 are the two standard rolls; the range also covers
// the narrow 48 mm and wide 112 mm rolls seen in the field.
export const RECEIPT_WIDTH = { min: 40, max: 120, def: 58 };

// Logo width (px). Thermal rolls and A4/A5 pages have very different usable widths,
// so each print family gets its own bounds and default.
export const LOGO_WIDTH = {
  thermal: { min: 40, max: 200, def: 80 }, // thermal roll
  a4: { min: 40, max: 300, def: 160 }, // A4 / A5 page
};

/**
 * Resolve a stored/typed width into a value that is always safe to render.
 *
 * - blank, non-numeric, 0 or negative -> the template default (never a 0-wide element)
 * - anything else -> clamped into [min, max]
 *
 * @param {*} value raw value from the form or the outlet record
 * @param {{min: number, max: number, def: number}} bounds
 * @returns {number}
 */
export const resolveWidth = (value, { min, max, def }) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return def;
  return Math.min(Math.max(n, min), max);
};

/** Thermal paper width in mm, safe to render. */
export const resolveReceiptWidth = (value) => resolveWidth(value, RECEIPT_WIDTH);

/**
 * Logo width in px, safe to render.
 * @param {"thermal"|"a4"} kind print family
 */
export const resolveLogoWidth = (value, kind = "thermal") =>
  resolveWidth(value, LOGO_WIDTH[kind] || LOGO_WIDTH.thermal);
